import { render, staticRenderFns } from "./BillingMinimumChargeIndex.vue?vue&type=template&id=c94e1ed4&scoped=true&"
import script from "./BillingMinimumChargeIndex.vue?vue&type=script&lang=js&"
export * from "./BillingMinimumChargeIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingMinimumChargeIndex.vue?vue&type=style&index=0&id=c94e1ed4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94e1ed4",
  null
  
)

export default component.exports